export default function Footer() {
  return (
    <p className="text-sm text-muted-foreground text-center">
      @2025 FellasCard.com
    </p>
  );
}